import React, { useContext, useEffect } from "react";


import { isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";
import { auth } from "../firebase-config";

import {
  Container,
  Typography,
} from "@mui/material";

import { AppContext } from "../Store";
import { useSnackbar } from "../shared/SnackbarProvider";

const FinishSignUp: React.FC = () => {
  const context = useContext(AppContext);
  const snack = useSnackbar();

  useEffect(() => {

    if (isSignInWithEmailLink(auth, window.location.href)) {

      let email = window.localStorage.getItem('emailForSignIn');
      if (!email) {
        email = window.prompt('Please provide your email for confirmation') || "";
      }

      signInWithEmailLink(auth, email, window.location.href)
        .then((result) => {
          window.localStorage.removeItem('emailForSignIn');
          snack("Signed in as " + result.user.displayName, "success");
          console.log({ result })
        })
        .catch((error) => {
          snack("Error signing in: " + error.message, "error");
        });
    }
  }, []);


  return (
    <Container
      maxWidth="lg"
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Typography variant="h3" gutterBottom>
        Finish Sign Up
      </Typography>
    </Container>
  );
};

export default FinishSignUp;
